module.exports = __webpack_public_path__ + "img/alipay.6b1792a3.png";